import { DomEvent } from "./DomEvent";
import { Event } from "./Event";
import { RadioButton } from "../components/radio/RadioButton";
import { RadioButtonGroup } from "../components/radio/RadioButtonGroup";
import { RadioGroup } from "../components/radio/RadioGroup";
import { RadioOption } from "../components/radio/RadioOption";
import { RadioOptionSelectionEvent } from "./RadioOptionSelectionEvent";

export class RadioButtonSelectionEvent extends RadioOptionSelectionEvent {
    constructor(component: RadioGroup, oldSelection: RadioOption, newSelection: RadioOption,
        originatingEvent?: Event|DomEvent) {
        super(component, oldSelection, newSelection, originatingEvent);
    }

    public override get group(): RadioButtonGroup {
        return super.group as RadioButtonGroup;
    }

    public get oldSelection(): RadioButton {
        return super.oldSelection as RadioButton;
    }

    public override get newSelection(): RadioButton {
        return super.newSelection as RadioButton;
    }

    public get event(): RadioButtonSelectionEvent {
        return super.event as RadioButtonSelectionEvent;
    }
}
